import { components } from "react-select";
import React from "react";
import { FieldData } from "./enums";

export const NoOptionsMessage = (props: any) => {
    return (
        <components.NoOptionsMessage {...props}>
            <span className="custom-css-class">Не найдено</span>
        </components.NoOptionsMessage>
    );
};

export function resolveFieldPath(fields: any[], path: string): FieldData[] | null {
    const segments = path.split('__');
    const result: FieldData[] = [];

    let currentFields = fields;

    for (const segment of segments) {
        const found = currentFields.find((f: any) => f.name === segment || f.field === segment);

        if (!found) return null;

        result.push(found);

        const related = found.related_fields;
        if (Array.isArray(related)) {
            currentFields = related;
        } else if (related) {
            currentFields = [related];
        } else {
            currentFields = [];
        }
    }

    return result;
}
